import React from 'react'
import {HashMap} from '../../lib/list'
import {BackgroundRepeatSetting, BackgroundPosition} from '../../lib/background'
import {BlockBase} from '../base'
import {NLPurchasePageBlock} from '../../nl-purchase-page'
import {BlockComponentProps} from '..'
import {SectionContext} from '../../Section'
import Column from './Column'

export interface RowBlock extends BlockBase {
  type: 'Row'
  background: {
    image: string
    color: string
    opacity: number
    position: BackgroundPosition
    repeat: BackgroundRepeatSetting
  }
  content: {
    background: {
      image: string
      color: string
      opacity: number
      position: BackgroundPosition
    }
    border: {
      width: number
      color: string
      radius: number
    }
  }
  margin: {
    top: number
    right: number
    bottom: number
    left: number
  }
  minHeight: number
  blocks: HashMap<NLPurchasePageBlock>
  fullWidth?: boolean
  visibility: 'all' | 'mobile_only' | 'desktop_only'
  numColumns: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  children?: React.ReactNode
}

export default function Row(props: RowBlock & BlockComponentProps) {
  const {template, children, numColumns, blocks} = props

  return (
    <SectionContext.Provider value={{calculateVisibility: () => {}}}>
      <div style={{display: 'flex'}}>
        {children ||
          Array.from({length: numColumns}, (_, i) => (
            <Column
              key={i}
              number={i + 1}
              blocks={blocks}
              template={template}
            />
          ))}
      </div>
    </SectionContext.Provider>
  )
}
